import { useEffect, useRef, useState } from "react";
import { setFullRatePopover } from "redux-share/slices/popoversSlice";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { ConditionName, zIndex } from "interfaces";
import { conditions } from "helpers";
import CloseIcon from "../../icon-components/closeIcon";
import { shallowEqual } from "react-redux";

const FullRate = () => {
    useAppSelector(({ popovers: { fullRatePopover } }) => ({ fullRatePopover }), shallowEqual);
    useAppSelector(({ videoData: { isComplexPortrait } }) => ({ isComplexPortrait }), shallowEqual);

    const [width, setWidth] = useState<number>(0);

    const dispatch = useAppDispatch();

    const intervalRef = useRef<any>(null);

    useEffect(() => {
        intervalRef.current = setInterval(() => setWidth((prev) => prev + 0.2), 10);

        return () => clearInterval(intervalRef.current);
    }, []);

    const handleClose = () => {
        dispatch(setFullRatePopover(false));
        clearInterval(intervalRef.current);
        setTimeout(() => dispatch(setFullRatePopover(undefined)), 500);
    };

    useEffect(() => {
        if (width >= 100) handleClose();
    }, [width]);

    const fullRateStyles = () => {
        let styles = "";

        if (conditions(ConditionName.isComplexPortrait))
            styles = `!pl-absolute pl-right-0 pl-mt-3 ${
                conditions(ConditionName.showFullRatePopover) ? "animate__backInRight" : "animate__backOutRight"
            }`;
        else if (conditions(ConditionName.isFullMobilePortrait))
            styles = `!pl-absolute pl-top-12 pl-left-3 pl-self-center pl-justify-center ${
                conditions(ConditionName.showFullRatePopover) ? "animate__backInLeft" : "animate__backOutLeft"
            }`;
        else
            styles = `!pl-absolute pl-top-4 pl-left-[80px] ${
                conditions(ConditionName.showFullRatePopover) ? "animate__backInDown" : "animate__backOutUp"
            }`;

        return styles;
    };

    const closeIcon = <CloseIcon className={`pl-w-3 pl-h-3 pl-stroke-secondary-50`} />;

    return (
        <div
            className={`pl-h-[38px] pl-flex pl-items-center animate__animated ${fullRateStyles()} pl-border pl-border-secondary-300`}
            style={{ zIndex: zIndex.fullrate }}
        >
            <div
                className={`pl-flex pl-flex-col pl-gap-[4px] pl-items-center pl-w-[210px] pl-h-full pl-rounded-r-[4px] pl-py-[10px] pl-px-2 pl-bg-secondary-100 dark:pl-bg-gray-800`}
            >
                <p className={`pl-w-full pl-text-[11px] pl-font-medium pl-text-black dark:pl-text-white`}>
                    ترافیک اینترنت شما تمام بها محاسبه می‌شود.
                </p>
                <div className={`pl-w-full pl-h-[2px] pl-bg-dark-8`}>
                    <div className={`pl-h-[2px] pl-bg-main-700`} style={{ width: `${width}%` }}></div>
                </div>
            </div>
            <div
                className={`pl-flex pl-justify-center pl-items-center pl-w-8 pl-h-full pl-rounded-l-[4px] pl-py-[10px] pl-cursor-pointer pl-bg-secondary-700 dark:pl-bg-gray-600`}
                onClick={handleClose}
            >
                {closeIcon}
            </div>
        </div>
    );
};

export default FullRate;
